import React from "react";
import { useField } from "formik";
import Notification from "../Notification";

type FormItemErrorProps = {
  readonly name: string;
};

function FormItemError({ name }: FormItemErrorProps) {
  const [, { error, touched }] = useField(name);
  if (!touched) {
    return null;
  }
  const errorString = (() => {
    if (!error) {
      return undefined;
    }
    if (typeof error === "string") {
      return error;
    }
    return JSON.stringify(error);
  })();
  return <Notification type="error">{errorString}</Notification>;
}

export default FormItemError;
